export class ApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`/api${path}`, {
    ...init,
    headers: init?.body ? { 'Content-Type': 'application/json', ...init.headers } : init?.headers
  });
  const payload = await response.json().catch(() => ({})) as { error?: string };
  if (!response.ok) throw new ApiError(payload.error || 'Errore di comunicazione.', response.status);
  return payload as T;
}

export function post<T>(path: string, data: unknown = {}): Promise<T> {
  return api<T>(path, { method: 'POST', body: JSON.stringify(data) });
}

export function put<T>(path: string, data: unknown): Promise<T> {
  return api<T>(path, { method: 'PUT', body: JSON.stringify(data) });
}

export function del<T>(path: string): Promise<T> {
  return api<T>(path, { method: 'DELETE', body: JSON.stringify({}) });
}
